import React, { Component } from 'react'
import TextField from 'material-ui/TextField'
import NumberField from 'material-ui-number-input'
import AlertContainer from 'react-alert'
import InputMask from 'react-input-mask'
import _ from 'lodash'
import './Contact.css'

const black = '#000';
const blue = '#215978';

const styles = {
  blackText: {
    color: black,
  },
  underlineFocusStyle: {
    borderColor: blue,
  },
  underlineStyle: {
    borderColor: blue,
  }
}

const alertOptions = {
  offset: 14,
  position: 'top left',
  theme: 'light',
  time: 2500,
  transition: 'scale'
}

export default class ContactCard extends Component {
  constructor(props) {
    super(props)

    let value = props && props.value ? props.value : '';
    let floatingLabelFixed = !!value;
    
    this.state = {
      fName: '',
      lName: '',
      company: '',
      email: '',
      phone: '',
      floatingLabelFixed,
    }
  }

  componentWillReceiveProps(nextProps){
    if(!nextProps.phone) {
      if (!_.isUndefined(this.refs.inputElement)) {
        this.refs.inputElement.setState({phone: ""})
      }
    }
  }

  sendEmail = () => {
    const { fName, lName, company, email, phone } = this.state
    const subject = `New Contact from NicholasPSmith.com`
    const body = `First Name: ${fName}\nLast Name: ${lName}\nCompany: ${company}\nEmail: ${email}\nPhone: ${phone}`
    fetch('https://35ix9g5a2h.execute-api.us-east-1.amazonaws.com/production/submit', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ subject, body })
    })
  }

  changePhoneNumber = event => {
    let phone = event && event.target && event.target.value ? event.target.value : '';
    let floatingLabelFixed = !!phone;
    this.setState({
        phone,
        floatingLabelFixed
    });
  }

  hackyClearPhoneNumberInput = () => {
    setTimeout(() => {
      var elements = document.querySelectorAll('[id^=undefined-undefined-]')
      elements.forEach(el => {
        el.value = ""
      })
    }, 300);
  }

  changeField = (e, field) => {
    this.setState({ [field]: e.target.value })
  }

  isValidEmail = email => {
    const atFirstIndex = email.indexOf('@')
    const atLastIndex = email.lastIndexOf('@')
    const dotFirstIndex = email.indexOf('.')
    const dotLastIndex = email.lastIndexOf('.')
    if (email.length > 5 && atFirstIndex !== -1 && dotFirstIndex !== -1) { // longer than 5, has an @ sign and a .
      if (atFirstIndex === atLastIndex) { // only 1 @
        if (atFirstIndex < dotLastIndex && dotLastIndex - atFirstIndex >= 3) { // @ comes before . AND there are at least 2 characters between @ and .
          if (email.length - dotLastIndex >= 3 && atFirstIndex >= 2) { // there are at lest 3 characters after . and at least 2 characters before @
            return true
          }
        }
      }
    }
    return false
  }

  collectInfo = () => {
    const { fName, email, phone } = this.state
    let validationMessage = 'Please enter more information'
    let validationType = 'error'
    if (fName.length > 1) {
      if (email.length >= 1 || phone.length >= 1) {
        if (email.length === 0 || (email.length >= 9 && this.isValidEmail(email))) { // we have either no email or a valid email
          if (phone.length === 0 || phone.length === 14) { // phone will be 14 characters including the 2 parens, 1 space, & 1 dash
            const {
              fName,
              lName,
              company,
              email,
              phone,
            } = this.state
            const contact = {
              fName,
              lName,
              company,
              email,
              phone,
            }
            this.sendEmail()
            //  clear fields
            this.setState({
              fName: '',
              lName: '',
              company: '',
              email: '',
              phone: '(',
              floatingLabelFixed: false,
            })
            this.hackyClearPhoneNumberInput()
            validationMessage = 'I will get back to you within 48 hours'
            validationType = 'success'
          } else {
            validationMessage = 'Make sure you entered your phone number correctly'
          }
        } else {
          validationMessage = 'Make sure you entered your email address correctly'
        }
      } else {
        validationMessage = 'Please enter a way for us to contact you'
      }
    } else {
      validationMessage = 'Please enter your name'
    }

    this.msg.show(validationMessage, {
      time: 2500,
      type: validationType,
    })
  }

  render() {
    const { underlineFocusStyle, underlineStyle, blackText, hintStyle } = styles;
    return (
      <div className="dreamcard">
        <AlertContainer ref={a => this.msg = a} {...alertOptions} />
        <h2>Contact Me</h2>
        <hr className="special" />
        <div className="form">
          <div className="row">
            <div className="col s6">
              <TextField
                underlineStyle={underlineStyle}
                underlineFocusStyle={underlineFocusStyle}
                floatingLabelStyle={blackText}
                floatingLabelFocusStyle={blackText}
                inputStyle={blackText}
                hintStyle={hintStyle}
                fullWidth={true}
                floatingLabelText="First Name"
                onChange={ e => this.changeField(e, 'fName')}
                value={this.state.fName}
              />
            </div>
            <div className="col s6">
              <TextField
                underlineStyle={underlineStyle}
                underlineFocusStyle={underlineFocusStyle}
                floatingLabelStyle={blackText}
                floatingLabelFocusStyle={blackText}
                inputStyle={blackText}
                hintStyle={hintStyle}
                fullWidth={true}
                floatingLabelText="Last Name"
                onChange={ e => this.changeField(e, 'lName')}
                value={this.state.lName}
              />
            </div>
          </div>
          <div className="row">
            <div className="col s12">
              <TextField
                underlineStyle={underlineStyle}
                underlineFocusStyle={underlineFocusStyle}
                floatingLabelStyle={blackText}
                floatingLabelFocusStyle={blackText}
                inputStyle={blackText}
                hintStyle={hintStyle}
                fullWidth={true}
                floatingLabelText="Company"
                onChange={ e => this.changeField(e, 'company')}
                value={this.state.company}
                />
            </div>
          </div>
          <div className="row">
            <div className="col s12">
              <TextField
                underlineStyle={underlineStyle}
                underlineFocusStyle={underlineFocusStyle}
                floatingLabelStyle={blackText}
                floatingLabelFocusStyle={blackText}
                inputStyle={blackText}
                hintStyle={hintStyle}
                fullWidth={true}
                floatingLabelText="Email"
                onChange={ e => this.changeField(e, 'email')}
                value={this.state.email}
                />
            </div>
          </div>
          <div className="row">
            <div className="col s12">
              <NumberField
                underlineStyle={underlineStyle}
                underlineFocusStyle={underlineFocusStyle}
                floatingLabelStyle={blackText}
                floatingLabelFocusStyle={blackText}
                inputStyle={blackText}
                hintStyle={hintStyle}
                fullWidth={true}
                floatingLabelText="Phone"
                onChange={this.changePhoneNumber}
                value={this.state.phone}
                floatingLabelFixed={this.state.floatingLabelFixed}
              >
                <InputMask type="tel" ref="inputElement" mask="(999) 999-9999" maskChar="" />
              </NumberField>
            </div>
          </div>

          <button className="btn" onClick={this.collectInfo}>Submit</button>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/contact.js